import { Component, OnInit } from '@angular/core';
import { QnaNavigationService } from './qna-navigation.service';

@Component({
  selector: 'aa-breadcrumb-nav',
  templateUrl: './breadcrumb-nav.component.html',
  styleUrls: ['./breadcrumb-nav.component.scss']
})
export class BreadcrumbNavComponent {

  constructor(public readonly navigation: QnaNavigationService) {

  }
}
